export default defineNuxtRouteMiddleware((to, from) => {
  const localeRoute = useLocaleRoute()
  const localePath = useLocalePath()
  const authStore = useAuthStore()
  const { sessionExpired } = useAuthentication()
  const isEmployee = authStore.isEmployee
  const normalizePath = localePath(from.path, 'en')

  // Let auth middleware handle direct login redirect with original destination. (cos we cant decide employee/user yet)
  if (sessionExpired.value) {
    return
  }

  if (to.path === '/') {
    return normalizePath.startsWith('/portal')
      ? navigateTo(localeRoute('/portal/dashboard'), { redirectCode: 301 })
      : navigateTo(localeRoute(isEmployee ? '/hub/dashboard' : '/portal/dashboard'), {
          redirectCode: 301,
        })
  }
  if (to.path === '/hub/' || to.path === '/hub') {
    return navigateTo(localeRoute(isEmployee ? '/hub/dashboard' : '/portal/dashboard'), {
      redirectCode: 301,
    })
  }

  if (to.path === '/portal/' || to.path === '/portal') {
    return navigateTo(localeRoute('/portal/dashboard'), { redirectCode: 301 })
  }
  if (to.path.startsWith('/hub') && !isEmployee) {
    return navigateTo(localeRoute('/portal/dashboard'), { redirectCode: 301 })
    // only employees can access the hub
  }
})
